module.exports = __webpack_public_path__ + "static/media/logo.bc0e3de5.png";